// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'

// Include in project
import styles from './index.module.scss'
import { useFormikContext } from 'formik'
import { ChipInput } from 'component'
import { convertRangeDate } from 'utils/convertDate'

const CampaignRestrictionsSpecialModeView: React.FC = () => {
  const { values } = useFormikContext<any>()
  const { t } = useTranslation()

  return (
    <section className={styles.container}>
      <h5>{t<string>('createNormalCampaign.campaignRestric')}</h5>

      <div className={styles.wrapperInput}>
        <h6 className={styles.textTitle}>{t<string>('common.targetType')}:</h6>
        <p>{values.campaign.targetType}</p>

        <h6 className={styles.textTitle}>{`Shop Type`}:</h6>
        <p>{values.campaign.shopType}</p>

        <h6 className={styles.textTitle}>{`Tag (Retailer)`}:</h6>
        <div className={styles.wrapperTags}>
          {values.campaign.tagRetainer &&
            values.campaign.tagRetainer.map((item: any, index: number) => (
              <ChipInput key={index} label={item.label} color="primary" />
            ))}
        </div>

        <h6 className={styles.textTitle}>{`Target Product`}:</h6>
        <div className={styles.wrapperTags}>
          {values.campaign.targetProduct &&
            values.campaign.targetProduct.map((item: any, index: number) => (
              <ChipInput key={index} label={item.label} color="primary" />
            ))}
        </div>

        <h6 className={styles.textTitle}>{t<string>('common.targetTypeValue')}:</h6>
        <div className={styles.wrapperTags}>
          {values.campaign.targetTypeValue &&
            values.campaign.targetTypeValue.map((item: any, index: number) => (
              <ChipInput key={index} label={item.label} color="primary" />
            ))}
        </div>

        <h6 className={styles.textTitle}>{t<string>('common.timeDuration')}:</h6>
        <p>{convertRangeDate(values.campaign.timeDuration)}</p>

        <h6 className={styles.textTitle}>{'Cal with SubRTL'}:</h6>
        <p>{values.campaign.isSubRTLCal ? 'Yes' : 'No'}</p>
      </div>
    </section>
  )
}
export default CampaignRestrictionsSpecialModeView
